module.exports = __webpack_public_path__ + "static/media/envelope.7823e1c2.svg";